import { Link } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Button from '@mui/material/Button';
import useMediaQuery from '@mui/material/useMediaQuery';
import { styled, Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';

// project imports

import AuthCardWrapper from '../AuthCardWrapper';
import ForgotPasswordForm from './auth-forms/ForgotPassordForm';
import { useState } from 'react';
import ForgotPasswordOtpVerification from './auth-forms/forgotPasswordOtpVerification';
import ForgotSuccess from './auth-forms/forgotSuccess';
// import RegisterSuccess from './auth-forms/registerSuccess';
type LoginType = 'email' | 'phone';
// type Registerlables = 'Sign up' | 'Otp verification' | 'Success';
// type RegisterSublables = 'Enter your credentials to continue' | 'Enter Otp to verify your mobile' | 'Successfully registered';
type RegisterStep = 'forgot' | 'verification' | 'forgotSuccess';

interface RegisterStepInfo {
    title: string;
    subTitle: string;
    data: any;
}

interface RegisterObj {
    [key: string]: RegisterStepInfo;
}

const registerObj: RegisterObj = {
    forgot: {
        title: 'Forgot Password',
        subTitle: '',
        data: ''
    },
    verification: {
        title: 'Otp verification',
        subTitle: 'Enter Otp to verify your mobile ',
        data: ''
    },
    forgotSuccess: {
        title: '',
        subTitle: '',
        data: ''
    }
};

// assets

// ===============================|| AUTH3 - REGISTER ||=============================== //

interface SignUpTabs {
    theme: Theme;
}

const SignUpTabs = styled(Tabs)(({ theme }: SignUpTabs) => ({
    '.MuiTab-root': {
        padding: '.3125rem .625rem',
        minHeight: '32px',
        // background:'#d4e8e1',
        backgroundColor: alpha(theme.palette.secondary.main, 0.2),

        color: '#212121',
        marginRight: '1px',
        fontSize: '0.875rem',
        width: 'calc(50% - 1px)',
        fontWeight: '700'
    },
    '.Mui-selected': {
        padding: '.3125rem .625rem',
        backgroundColor: theme.palette.dark.dark,
        minHeight: '32px',
        color: '#fff !important',
        fontSize: '0.875rem',
        width: '100%',
        fontWeight: '700',
        maxWidth: '100% !important'
    },
    '.MuiTabs-indicator': {
        display: 'none'
    }
}));

const ForgotPassword = ({ forceOpen }: { forceOpen: Function }) => {
    const theme = useTheme();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
    // const [activeTab, setActiveTab] = useState<LoginType>('email');
    const [registerStep, setRegisterStep] = useState<RegisterStep>('forgot');

    // Function to get data for the current step
    const getCurrentStepData = (): RegisterStepInfo => {
        return registerObj[registerStep];
    };

    // Handler function to update the step
    const handleStepChange = (newStep: RegisterStep) => {
        setRegisterStep(newStep);
    };

    const getRegisterData = (newdata: any) => {
        return (registerObj[registerStep].data = newdata);
    };
    // Call getCurrentStepData whenever the registerStep changes
    const currentStepData = getCurrentStepData();

    return (
        <Grid container direction="column" justifyContent="flex-end" sx={{ backgroundColor:'#050505',  }}>
            <Grid item xs={12}>
                <Grid container justifyContent="center" alignItems="center">
                    <Grid item sx={{ margin: '0px' }}>
                        <AuthCardWrapper>
                            <Grid
                                item
                                container
                                alignItems="center"
                                justifyContent="center"
                                sx={{ backgroundColor:'#050505', margin: '0px' }}
                            >
                                <Grid item sx={{ margin: '0px' }} xs={12}>
                                    <Grid
                                        container
                                        direction={matchDownSM ? 'column-reverse' : 'row'}
                                        alignItems="center"
                                        justifyContent="center"
                                    >
                                        <Grid item>
                                            <Stack alignItems="center" justifyContent="center" spacing={1}>
                                                <Typography
                                                    // color={theme.palette.secondary.main}
                                                    gutterBottom
                                                    variant={matchDownSM ? 'h3' : 'h1'}
                                                    sx={{
                                                        color: theme.palette.secondary.main,
                                                        marginBottom: '1.5625rem !important',
                                                        textTransform: 'uppercase',
                                                        fontSize: '1.25rem',
                                                        fontWeight: '700',
                                                        lineHeight: '1.5625rem '
                                                    }}
                                                >
                                                    {currentStepData.title}
                                                </Typography>
                                                <Grid item className="3333" sx={{ width:'450px',
                                                    [theme.breakpoints.down(600)]: {
                                                        width:'336px'
                                                    },
                                                }}>
                                                    {currentStepData.title && (
                                                        <Typography
                                                            variant="caption"
                                                            fontSize="16px"
                                                            textAlign={matchDownSM ? 'center' : 'inherit'}
                                                        >
                                                            {currentStepData.subTitle}
                                                        </Typography>
                                                    )}
                                                    {registerStep === 'forgotSuccess' && (
                                                        <ForgotSuccess forceOpen={forceOpen} />

                                                        // <Typography
                                                        //     component={Link}
                                                        //     to={'/login'}
                                                        //     variant="subtitle1"
                                                        //     sx={{ textDecoration: 'none' }}
                                                        // >
                                                        //     here
                                                        // </Typography>
                                                    )}
                                                </Grid>
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid item sx={{ display: registerStep === 'forgot' ? 'block' : 'none', padding: '0px' }}>
                                        <ForgotPasswordForm
                                            currentStepData={currentStepData}
                                            handleStepChange={handleStepChange}
                                            getRegisterData={getRegisterData}
                                        />
                                    </Grid>
                                    <Grid item sx={{ display: registerStep === 'verification' ? 'block' : 'none' }}>
                                        <ForgotPasswordOtpVerification
                                            currentStepData={currentStepData}
                                            handleStepChange={handleStepChange}
                                            registerObj={registerObj}
                                        />
                                    </Grid>
                                </Grid>
                                {registerStep !== 'forgotSuccess' && (
                                    <>
                                        <Grid item xs={12} sx={{ padding: '10px 0px' }}>
                                            {/* <Divider /> */}
                                        </Grid>
                                    </>
                                )}
                            </Grid>
                        </AuthCardWrapper>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default ForgotPassword;

// import { Link } from 'react-router-dom';

// // material-ui
// import { useTheme } from '@mui/material/styles';
// import Divider from '@mui/material/Divider';
// import Grid from '@mui/material/Grid';
// import Typography from '@mui/material/Typography';
// import useMediaQuery from '@mui/material/useMediaQuery';

// // project imports
// import AuthWrapper1 from '../AuthWrapper1';
// import AuthCardWrapper from '../AuthCardWrapper';
// import Logo from 'ui-component/Logo';
// import AuthForgotPassword from './auth-forms/AuthForgotPassword';
// import AuthFooter from 'ui-component/cards/AuthFooter';

// // ============================|| AUTH3 - FORGOT PASSWORD ||============================ //

// const ForgotPassword = ({ forceOpen }: { forceOpen: Function }) => {
//     const theme = useTheme();
//     const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));

//     return (
//         <AuthWrapper1>
//             <Grid container direction="column" justifyContent="flex-end" sx={{ minHeight: '100vh' }}>
//                 <Grid item xs={12}>
//                     <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: 'calc(100vh - 68px)' }}>
//                         <Grid item sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>
//                             <AuthCardWrapper>
//                                 <Grid container spacing={2} alignItems="center" justifyContent="center">
//                                     <Grid item sx={{ mb: 3 }}>
//                                         <Link to="#">
//                                             <Logo />
//                                         </Link>
//                                     </Grid>
//                                     <Grid item xs={12}>
//                                         <Grid container alignItems="center" justifyContent="center" textAlign="center" spacing={2}>
//                                             <Grid item xs={12}>
//                                                 <Typography
//                                                     color={theme.palette.secondary.main}
//                                                     gutterBottom
//                                                     variant={matchDownSM ? 'h3' : 'h2'}
//                                                 >
//                                                     Forgot password?
//                                                 </Typography>
//                                             </Grid>
//                                             <Grid item xs={12}>
//                                                 <Typography variant="caption" fontSize="16px" textAlign="center">
//                                                     Enter your email address below and we&apos;ll send you password reset OTP.
//                                                 </Typography>
//                                             </Grid>
//                                         </Grid>
//                                     </Grid>
//                                     <Grid item xs={12}>
//                                         <AuthForgotPassword />
//                                     </Grid>
//                                     <Grid item xs={12}>
//                                         <Divider />
//                                     </Grid>
//                                     <Grid item xs={12}>
//                                         <Grid item container direction="column" alignItems="center" xs={12}>
//                                             <Typography component={Link} to={'/login'} variant="subtitle1" sx={{ textDecoration: 'none' }}>
//                                                 Already have an account?
//                                             </Typography>
//                                         </Grid>
//                                     </Grid>
//                                 </Grid>
//                             </AuthCardWrapper>
//                         </Grid>
//                     </Grid>
//                 </Grid>
//                 <Grid item xs={12} sx={{ m: 3, mt: 1 }}>
//                     <AuthFooter />
//                 </Grid>
//             </Grid>
//         </AuthWrapper1>
//     );
// };

// export default ForgotPassword;
